import { AxiosError } from 'axios';
import { GET_SCHOOL_CANDIDATE_PAYMENT_RECEIPT } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../../hooks/query';
import { GET_SCHOOL_CANDIDATE_PAYMENT_RECEIPT_QUERY_KEY } from '../../constants/queryKeys';

interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

export interface SchoolCandidatePaymentReceiptInfo {
  transactionNo: string;
  paymentDateTime: string;
  paymentMethod: string;
  totalExamFee?: string;
  referenceNo: string;
  gstRegNo?: string;
}

export const useGetSchoolCandidatePaymentReceipt = ({ uuid, onSuccess, onError }: Input) => {
  const getSchoolCandidatePaymentReceipt = async () => {
    const res = await axiosClient.get<SchoolCandidatePaymentReceiptInfo>(
      GET_SCHOOL_CANDIDATE_PAYMENT_RECEIPT(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_SCHOOL_CANDIDATE_PAYMENT_RECEIPT_QUERY_KEY, uuid],
    getSchoolCandidatePaymentReceipt,
    {
      onSuccess,
      onError,
    }
  );
};
